import intl from "react-intl-universal";
import React, {useCallback} from "react";

import {useAppState, useRootStore} from "@stores/AppStateContext";

import {UnsavedChangesConfirmParams} from "../modal-names";

import {ModalConfirm} from "../../../components/ModalConfirm/ModalConfirm"


import {unsavedChangesManager} from "@stores/UnsavedChangesManager";


export const UnsavedTakeQuizConfirm = (
    {openPageByNameArguments}: UnsavedChangesConfirmParams
) => {

    const appState = useAppState();
    const rootStore = useRootStore();

    const exitWithoutSave = () => {
        unsavedChangesManager.clearAndLeave();
        // @ts-ignore
        rootStore.view.openPageByName(...openPageByNameArguments)
        handleClose()
    }

    const handleClose = useCallback(() => {
        appState.setModal(null);
        appState.setContextMenu(null);
    }, []);

    return (
        <ModalConfirm
            open={true}
            type={'warning'}
            header={intl.get('unsavedTakeQuizConfirm.title').d('Progress Not Saved!')}
            onClose={handleClose}
            confirmText={intl.get('unsavedTakeQuizConfirm.save_and_leave').d('Continue Test')}
            onConfirm={async () => handleClose()}
            onCancel={exitWithoutSave}
            cancelText={intl.get('unsavedTakeQuizConfirm.discard_and_leave').d('Exit Test')}
            maxWidth={640}
        >
            {intl.get('unsavedTakeQuizConfirm.Modal.Text.firstPart').d("Looks like you're about to leave the test before completing it.")} &thinsp;
                <span className='body-large-bold'>
                     {intl.get('unsavedTakeQuizConfirm.Modal.Text.boldPart').d("Keep in mind, your progress will not be saved, and you will need to start over in your next attempt.")}
                </span>
        </ModalConfirm>
    );
};
